import {FreewallFilenamePrefix} from "@rezonence/sdk";
import {TemplateFileSuffix} from "@rezonence/core";

export const freewallConfigFilename = `${FreewallFilenamePrefix.Ad}${TemplateFileSuffix.Conf}`;